const state = {
  loading: false,
  loadingButton: false,
  loadingBoard: false,
  loadingDrawer: false,
}

const getters = {
  isLoading: (state) => state.loading,
  isLoadingButton: (state) => state.loadingButton,
  isLoadingBoard: (state) => state.loadingBoard,
  isLoadingDrawer: (state) => state.loadingDrawer,
}

const mutations = {
  setIsLoading: (state, status) => {
    state.loading = status
  },
  setIsLoadingButton: (state, status) => {
    state.loadingButton = status
  },
  setIsLoadingBoard: (state, status) => {
    state.loadingBoard = status
  },
  setIsLoadingDrawer: (state, status) => {
    state.loadingDrawer = status
  }
}

export default {
  state,
  getters,
  mutations,
}
